import React from "react";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { useParams } from "react-router-dom";
import { initializeAuth, getValidationById } from "../services/apiService";
import { setSelectedItem } from "../redux/dataSlice";
import ViewDetails from "./View/ViewDetails";

const Home = () => {
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const { id } = useParams();

  const getValidation = async (id) => {
    if (id) {
        dispatch(setSelectedItem(null));
        console.log("Selected validation:", id);
        await initializeAuth(instance, accounts);
        const response = await getValidationById(id);
        dispatch(setSelectedItem(response));      
    }
  };

  if (id) {
    getValidation(id);
  }

  return (
    <>
      <ViewDetails />
    </>
  )
};

export default Home;
